import { COLORS, TEXT_COLORS } from '../constants';

/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-button';

/**
 * A list of monochromatic buttons.
 * @type {String[]}
 */
export const MONOCHROME_BUTTONS = [
    COLORS.GREY,
    COLORS.LIGHT_GREY,
    COLORS.BLACK
];

/**
 * A mapping of non-standard supported colors to their standard counterparts.
 * @type {Object<String>}
 */
export const COLOR_MAP = {
    [COLORS.BLACK]: COLORS.GREY,
    [COLORS.LIGHT_GREY]: COLORS.GREY,
    [TEXT_COLORS.DARK_GREY]: COLORS.GREY
};

/**
 * A mapping of non-standard color weights for ghost buttons.
 * @type {Object<String>}
 */
export const GHOST_COLOR_WEIGHT_MAP = {
    [COLORS.LIGHT_GREY]: 800,
    [COLORS.GREY]: 1000,
    [COLORS.BLACK]: 1100
};

/**
 * A mapping of non-standard icon color weights.
 * @type {Object<String>}
 */
export const ICON_COLOR_WEIGHT_MAP = {
    [COLORS.BLACK]: 1200
};

/**
 * A mapping of non-standard background colors.
 * @type {Object<String>}
 */
export const BACKGROUND_COLOR_MAP = {
    [COLORS.LIGHT_GREY]: COLORS.GREY,
    [COLORS.GREY]: COLORS.GREY,
    [COLORS.BLACK]: COLORS.GREY
};

/**
 * A mapping of non-standard background color weights.
 * @type {Object<String>}
 */
export const BACKGROUND_COLOR_WEIGHT_MAP = {
    [COLORS.LIGHT_GREY]: 300,
    [COLORS.GREY]: 800
};
